import { Component, HostListener, EventEmitter, Output } from '@angular/core'
import moment from 'moment'

export interface EventFilter {
  fromDate: string
  toDate: string
  text: string
}

@Component({
  selector: 'app-event-filter',
  templateUrl: './event-filter.component.html',
  styleUrls: ['./event-filter.component.scss'],
  standalone: false,
})
export class EventFilterComponent {
  filter: EventFilter = { fromDate: '', toDate: '', text: '' }
  showFilters = false
  isDesktop = window.innerWidth >= 768

  @Output() filtersChange = new EventEmitter<EventFilter>()

  @HostListener('window:resize')
  onResize() {
    this.isDesktop = window.innerWidth >= 768
    if (this.isDesktop) this.showFilters = true
  }

  toggleFilters() {
    if (!this.isDesktop) this.showFilters = !this.showFilters
  }

  emit() {
    this.filtersChange.emit({ ...this.filter })
  }
}
